/**
 * @module app.pp
 */

abstract class MyAuthorizationsEvent { }
export class MyAuthorizationsReloadEvent extends MyAuthorizationsEvent { }

abstract class UpdateAuthRequestEvent { }
export class SaveAuthDetailsEvent extends UpdateAuthRequestEvent {
    constructor(public continueUpdate: boolean = false) {
        super();
        return Object.assign<SaveAuthDetailsEvent, SaveAuthDetailsEvent>(this, { continueUpdate: continueUpdate });
    }
}
